export const MAP_ASSET_REMOTE_PROD_HOST = 'https://staticcontent.knowledgehook.com';
export const MAP_ASSET_REMOTE_PROD_PATH = 'content/khg/maps/v9';
